<template>
	<div class="container">
		<div class="title-wrap">
			<h2 class="title">{{ boardName }}</h2> <el-button type="primary" @click="$router.push('/board/'+$route.params.id)" style="display: inline-block; float: right;">목록으로</el-button>
		</div>
			<el-input placeholder="제목" v-model="title" clearable> </el-input>

    <froala :tag="'textarea'" :config="config" v-model="content"></froala>
    <br/>
    <p class="error">{{writeErrorText}}</p>
    <div style="float: right; display: inline-block;">
      <el-button type="success" :disabled="!writeLoad" @click="write">{{writeButtonText}}</el-button>
    </div> 
    
	</div>
</template>

<script>
import axios from "axios";
import {apiUrl} from '../constants/config';
import { Loading } from 'element-ui';


var loadingInstance;


export default {
	data() {
		return {
      writeLoad: true,
			writeButtonText: "작성",
			writeErrorText: "",
			title: "",
      content: "",
      boardName: "",
      config: {
      key: "wFE7nE5F4B3C2B10A5A5fvusH-8E2pd1efxE2F2G2G1B10B2C2E6C1B1==",
      heightMin: 300,
      heightMax: 500,
      language: 'ko',
      imageUploadURL: apiUrl + "/article/uploadImage",
      imageUploadMethod: 'POST',
      imageMaxSize: 100 * 1024 * 1024,
      imageAllowedTypes: ['jpeg', 'jpg', 'png', 'gif'],
      toolbarButtons: [['bold', 'italic', 'underline', 'strikeThrough', 'fontFamily', 'fontSize', 'textColor', 'backgroundColor'], ['insertLink', 'insertImage', 'insertVideo', 'insertTable', 'emoticons', 'fontAwesome', 'specialCharacters', 'embedly', 'insertHR'], ['undo', 'redo', 'fullscreen', 'html']]
      }
		}
	},
	methods: {
    write(){
      this.writeLoad = false;
      this.writeButtonText = "작성 중";
      this.writeErrorText = "";

      if(this.title == ""){
        this.writeLoad = true;
        this.writeButtonText = "작성";
        this.writeErrorText = "제목을 입력해주세요.";
        return;
      }

      if(this.content == ""){
        this.writeLoad = true;
        this.writeButtonText = "작성";
        this.writeErrorText = "내용을 입력해주세요.";
        return;
      }

      var vm = this;
      axios.post(apiUrl+'/board/'+this.$route.params.id+'/write', {title: vm.title, content: vm.content}, { withCredentials: true })
    .then(function(response) {
      if(response.data.success){
        vm.$swal.fire(
						'게시글을 작성했습니다.',
						"게시판에서 게시글을 조회하실 수 있습니다.",
						'success'
					).then(() => {
						vm.$router.push("/board/"+vm.$route.params.id);
					})
      }
      else{
        vm.writeErrorText = response.data.message;
        vm.writeLoad = true;
        vm.writeButtonText = "작성";
        return;
      }
    })
    .catch(function(error) {
      console.log(error);
    });

    }

	},
	mounted(){

},
  beforeCreate(){
    loadingInstance = Loading.service({ fullscreen: true });

    var vm = this;
    axios.get(apiUrl+'/board/'+this.$route.params.id+'/', { withCredentials: true })
    .then(function(response) {
      if(response.data.success && response.data.canWrite){
        vm.boardName = response.data.boardName;
        loadingInstance.close();
      }
      else{
      vm.$router.push("/");
      }
    })
    .catch(function(error) {
      console.log(error);
    });
  },

}
</script>

<style scoped>

.box-card {
  margin-bottom: 15px;
  cursor: pointer;
}

.error {
  display: inline-block;
  color: red;
  font-size: 14px;
}

</style>
